"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDiaryEntryToApi = exports.mapApiToDiaryEntryAdvanced = exports.mapApiToDiaryEntry = void 0;
const tech_1 = require("../../../tech");
const DiaryEntryDto_1 = require("../interface/DiaryEntryDto");
const diaryTypeReplace = [
    {
        be: 'zavada',
        fe: 'závada'
    }
];
const mapDiaryTypeToApi = (typ) => {
    return diaryTypeReplace.reduce((current, ad) => current.replace(ad.fe, ad.be), typ);
};
const mapApiToDiaryType = (typ) => {
    return diaryTypeReplace.reduce((current, ad) => current.replace(ad.be, ad.fe), typ);
};
const mapApiToDiaryEntry = (response) => {
    const parentId = (0, tech_1.apiToNumber)(response.parental_hlaseni_id);
    return {
        id: (0, tech_1.apiToNumber)(response.hlaseni_id),
        datum: (0, tech_1.apiToDate)(response.datum_hlaseni) ?? new Date(),
        provedl: (0, tech_1.apiToString)(response.provedl),
        text: (0, tech_1.apiToString)(response.text_hlaseni),
        poznamka: (0, tech_1.apiToString)(response.poznamka),
        typ: (0, tech_1.apiToStringEnum)(mapApiToDiaryType(response.typ_hlaseni), DiaryEntryDto_1.DIARY_ENTRY_TYPES) ?? DiaryEntryDto_1.DIARY_ENTRY_TYPES[0],
        email: (0, tech_1.apiToString)(response.email),
        uzivatel: (0, tech_1.apiToString)(response.uzivatel),
        telefon: (0, tech_1.apiToString)(response.tel_cislo),
        parentId: parentId < 0 ? undefined : parentId,
        opraveno: (0, tech_1.apiToBoolean)(response.opraveno)
    };
};
exports.mapApiToDiaryEntry = mapApiToDiaryEntry;
const mapApiToDiaryEntryAdvanced = (response, mapDetail) => {
    return {
        value: (0, exports.mapApiToDiaryEntry)(response),
        detail: mapDetail(response)
    };
};
exports.mapApiToDiaryEntryAdvanced = mapApiToDiaryEntryAdvanced;
const mapDiaryEntryToApi = (diaryEntry, createMode) => {
    const authState = (0, tech_1.getAuthInnerState)();
    if (createMode) {
        return {
            typ_hlaseni: (0, tech_1.stringToApi)(mapDiaryTypeToApi(diaryEntry.typ)),
            provedl: (0, tech_1.stringToApi)(diaryEntry.provedl),
            email: (0, tech_1.stringToApi)(diaryEntry.email),
            tel_cislo: (0, tech_1.stringToApi)(diaryEntry.telefon),
            text_hlaseni: (0, tech_1.stringToApi)(diaryEntry.text),
            DXdatum_hlaseni: (0, tech_1.dateToApi)(diaryEntry.datum),
            poznamka: (0, tech_1.stringToApi)(diaryEntry.poznamka),
            //opraveno: 1,
            IXopraveno: '0',
            parental_hlaseni_id: (0, tech_1.numberToApi)(diaryEntry.parentId ?? -1),
            uzivatel: authState.user?.userInfo?.email ?? '',
        };
    }
    else { //edit mode
        return {
            typ_hlaseni: (0, tech_1.stringToApi)(mapDiaryTypeToApi(diaryEntry.typ)),
            provedl: (0, tech_1.stringToApi)(diaryEntry.provedl),
            email: (0, tech_1.stringToApi)(diaryEntry.email),
            tel_cislo: (0, tech_1.stringToApi)(diaryEntry.telefon),
            text_hlaseni: (0, tech_1.stringToApi)(diaryEntry.text),
            DXdatum_hlaseni: (0, tech_1.dateToApi)(diaryEntry.datum),
            poznamka: (0, tech_1.stringToApi)(diaryEntry.poznamka),
            IXopraveno: (0, tech_1.booleanToApi)(diaryEntry.opraveno),
            //parental_hlaseni_id : numberToApi(diaryEntry.parentId ?? -1),
            //uzivatel : '',
        };
    }
};
exports.mapDiaryEntryToApi = mapDiaryEntryToApi;
